// R6-3 — THE SPREADS THE MEMBER PICKS FROM, MOVED VERBATIM OUT OF App.tsx.
//
// Both lists carry the SERVER'S spread keys. That is the whole reason they are worth a gate: a key
// here that the server does not know silently falls back to a different spread
// (`TAROT_SPREADS[spread] || TAROT_SPREADS["three-card"]`), so she chooses the Celtic Cross and is
// read a three-card. Nothing errors, nothing logs, and the reading is against a layout nobody laid.
// `scripts/r6-catalogs.mjs` diffs both lists against `TAROT_SPREADS` on the server rather than
// against a copy of them.
//
// This module imports NOTHING, which is the entry requirement for that loader.

// T2: EXACTLY five spreads, all drawn from our own deck (T-batch), shown in their real layout (T3).
export const TAROT_CATEGORIES = [
  { key: "daily", label: "Daily Card", blurb: "One card for the energy of today.", spread: "single" },
  { key: "three-card", label: "Three Card Spread", blurb: "Past, present, and where it is heading.", spread: "three-card" },
  { key: "celtic-cross", label: "Celtic Cross", blurb: "The full ten-card spread on your question.", spread: "celtic-cross" },
  { key: "tree-of-life", label: "Tree of Life", blurb: "Ten cards on the Kabbalistic tree.", spread: "tree-of-life" },
  { key: "timing", label: "Analyze Timing", blurb: "When the cards say it is likely to move.", spread: "timing" },
  // N8-2: a first-class choice, not a fallback. The cards come out for the question with no positional
  // layout, and the reading is forbidden from inventing one (spreadPositionLaw, server side).
  { key: "no-spread", label: "No Spread", blurb: "Cards pulled for your question, read without positions.", spread: "no-spread" },
];

// N8-3: what the member tells the analyzer she laid. The site's own spreads plus no spread at all. The
// keys are the SERVER'S spread keys, so the dropdown and the engine cannot drift apart.
export const ANALYZE_SPREADS = [
  { key: "no-spread", label: "No spread, just cards" },
  { key: "three-card", label: "Three Card Spread (3 cards)" },
  { key: "situation", label: "Situation, Challenge, Guidance (3 cards)" },
  { key: "love", label: "Love spread (3 cards)" },
  { key: "work", label: "Work spread (3 cards)" },
  { key: "celtic-cross", label: "Celtic Cross (10 cards)" },
  { key: "tree-of-life", label: "Tree of Life (10 cards)" },
  { key: "single", label: "One card" },
];
